import { Clock, GitBranch, Mail, MessageSquare, Phone, Smartphone, Users, Zap } from "lucide-react";
import React, { useState } from "react";
import { NodeActions } from "./node-actions";
import { CanvasNodeProps } from "../../../../pages/journey/types";

const nodeTypes = [
    { type: "trigger", label: "Trigger", icon: Zap, color: "bg-emerald-500" },
    { type: "segment", label: "Segment", icon: Users, color: "bg-blue-500" },
    { type: "decision", label: "Decision", icon: GitBranch, color: "bg-orange-500" },
    { type: "delay", label: "Delay", icon: Clock, color: "bg-pink-500" },
    { type: "sms", label: "SMS", icon: MessageSquare, color: "bg-emerald-500" },
    { type: "whatsapp", label: "WhatsApp", icon: MessageSquare, color: "bg-emerald-500" },
    { type: "ai_call", label: "AI Call", icon: Phone, color: "bg-purple-500" },
    { type: "rcs", label: "RCS", icon: Smartphone, color: "bg-blue-500" },
    { type: "email", label: "Email", icon: Mail, color: "bg-blue-500" },
];

export const CanvasNode: React.FC<CanvasNodeProps> = ({
    node,
    isSelected,
    onClick,
    onDragStart,
    onDelete,
    onAddNode,
}) => {
    const [showActions, setShowActions] = useState(false);
    const nodeType = nodeTypes.find((t) => t.type === node.type);

    if (!nodeType) return null;

    const Icon = nodeType.icon;

    return (
        <div
            className={`absolute cursor-pointer transition-all ${isSelected ? "z-10" : "z-0"}`}
            style={{ left: node.position.x, top: node.position.y }}
            onClick={onClick}
            onMouseEnter={() => setShowActions(true)}
            onMouseLeave={() => setShowActions(false)}
        >
            <NodeActions
                node={node}
                onDelete={onDelete}
                onAddNode={onAddNode}
                visible={showActions || isSelected}
            />

            <div
                onMouseDown={(e) => onDragStart(e, node.id)}
                className={`min-w-48 bg-white rounded-lg border-2 shadow-sm transition-all ${
                    isSelected
                        ? "border-teal-500 shadow-md"
                        : "border-gray-200 hover:border-gray-300 hover:shadow-md"
                    }`}
            >
                <div className={`flex items-center space-x-3 px-4 py-3 rounded-t-lg ${nodeType.color}`}>
                    <Icon className="w-5 h-5 text-white" />
                    <span className="text-sm font-semibold text-white">
                        {nodeType.label}
                    </span>
                </div>
                
                <div className="p-4">
                    <p className="text-sm text-gray-700 mb-2">
                        {node.data?.label || "Configure node..."}
                    </p>
                    {node.data?.description && (
                        <p className="text-xs text-gray-500">{node.data.description}</p>
                    )}
                </div>
            </div>

            <div className={`absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 rounded-full border-2 ${
                isSelected ? "bg-teal-500 border-teal-500" : "bg-white border-gray-300"
            }`}></div>
        </div>
    );
};